export const INSTALLATION_TYPES = {
  CLOUD: 'cloud',
  ENTERPRISE: 'enterprise',
  CUSTOM: 'custom',
  COMMUNITY: 'community',
};
